<template>
  <div class="literature">
    <div class="head-dec"></div>
    <div class="mid-panel">
      <div class="search-panel box">
        <el-input placeholder="请输入内容" v-model="searchValue" style="width: 807px; margin-top: 30px">
          <template slot="prepend"><i class="el-icon-search"></i></template>
          <template slot="append">
            <div class="custom-btn" style="background-color: #7c1823" @click="handleSearch">搜索</div>
          </template>
        </el-input>
        <div class="pop-search">
          <div class="word">热门搜索:</div>
          <div class="word v" v-for="(item, index) of searchKeywords" :key='index' @click="pickWord(item)">{{ item }}</div>
        </div>
      </div>
      <div class="index-tips box" v-if="!$isPhone">
        <div class="word-tips">
          <label>拼音索引</label>
          <div class="word" :class="{ active: curAlpha === '' }" style="height: 24px" @click="changeAlpha('')">全部</div>
          <div class="alpha-words">
            <div class="word" :class="{ active: curAlpha === a }" v-for="(a, index) in alphas" :key="index" @click="changeAlpha(a)">
              {{ a }}
            </div>
          </div>
        </div>
        <div class="word-tips" style="margin-top: 25px">
          <label>排序方式</label>
          <div class="word" :class="{ active: sortOrder === order.val }" v-for="(order, index) in orderTypeList" :key="index" @click="changeOrder(order.val)">
            {{ order.name }}
          </div>
        </div>
        <div class="classification">
          <div class="item" :class="{ active: curClass === item.key }" v-for="item in classList" :key="item.key" @click="changeClass(item.key)">
            <label>{{ item.name }}</label>
            <!-- <div class="text">{{ item.num }}</div> -->
          </div>
        </div>
      </div>
      <div class="books box">
        <div class="part-title">
          &diams;<span class="inline-title">全部数据</span><el-tag type="danger" style="margin-left: 40px" v-show="queryTag !== '' && isAdSearch === true">{{ queryTag }}</el-tag>
        </div>
        <book-list  :records="records"/>
        <div class="bottom-tools">
          <div class="icon first-page" @click="curPage = 1"></div>
          <div class="icon pre" @click="turnPage(-1)"></div>
          <div class="pager"><el-input v-model="curPage" style="width: 70px"></el-input>&nbsp;/&nbsp;{{ total }}</div>
          <div class="icon next" @click="turnPage(1)"></div>
          <div class="icon last-page" @click="curPage = total"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import bookList from './bookList'
import { getSearchParams, Exchange } from '@/utils'
import api from '@/api'
import userActionsApi from '@/api/userActions.js'
import adConfig from '@/components/advanced-search/config.json'
const alphas = []
let start = 'A'.charCodeAt(0) // 65
let last = 'Z'.charCodeAt(0) // 90

for (start; start <= last; start++) {
  alphas.push(String.fromCharCode(start))
}
export default {
  data () {
    return {
      searchValue: '',
      alphas,
      curPage: 1,
      total: 100,
      pageSize: 8,
      classList: [
        {
          name: '全部',
          key: '全部',
          num: 0
        },
        {
          name: '经部',
          key: '经部',
          num: 0
        },
        {
          name: '史部',
          key: '史部',
          num: 0
        },
        {
          name: '子部',
          key: '子部',
          num: 0
        },
        {
          name: '集部',
          key: '集部',
          num: 0
        }
      ],
      orderTypeList: [
        {
          name: '默认',
          val: ''
        },
        {
          name: '首字母拼音',
          val: 'pinyinIndex'
        },
        {
          name: '更新时间',
          val: 'updatedAt'
        }
      ],
      queryTag: '',
      curClass: '全部',
      curAlpha: '',
      sortOrder: '',
      advacedFilters: '',
      isAdSearch: false,
      records: [],
      searchKeywords: [],
      personalKeywords: []
    }
  },
  components: {
    bookList
  },
  methods: {
    searchBooks (needCount) {
      if (this.searchValue !== '') {
        userActionsApi.addUserAction({
          actionCode: 'resourceSearch',
          keyword: this.searchValue,
          terminalType: this.$isPhone ? 'mobile' : 'pc'
        })
      }

      api
        .bookSearch({
          pageIndex: this.curPage,
          pageSize: this.pageSize,
          searchValue: Exchange(this.searchValue, false),
          fdc: this.curClass,
          sortOrder: this.sortOrder,
          pinyinIndex: this.curAlpha
        })
        .then(res => {
          // if (needCount) this.getCount()
          this.total = Math.ceil(res.count / this.pageSize)
          this.records = res.rows
        })
    },
    adSearchBooks (needCount) {
      let type = this.curClass
      let form = this.advacedFilters
      api
        .bookSearch({
          pageIndex: this.curPage,
          pageSize: this.pageSize,
          advacedFilters: JSON.stringify({
            category: type,
            ...form
          }),
          sortOrder: this.sortOrder,
          pinyinIndex: this.curAlpha
        })
        .then(res => {
          if (needCount) this.getCount()
          this.records = res
        })
    },
    handleSearch () {
      this.queryTag = ''
      this.curPage = 1
      this.isAdSearch = false
      this.searchBooks(true)
    },
    handleAdSearch (type, form) {
      this.curPage = 1
      this.curClass = type
      this.isAdSearch = true
      this.advacedFilters = form
      let config = adConfig[type]
      let arr = []
      for (let _c of config) {
        if (form[_c.prop] !== '') arr.push(`${_c.label}:${form[_c.prop]}`)
      }
      this.queryTag = arr.join(' 并且 ')
      this.adSearchBooks(true)
    },
    getData (needCount = true) {
      this.isAdSearch ? this.adSearchBooks(needCount) : this.searchBooks(needCount)
    },
    turnPage (num) {
      let tPage = this.curPage + num
      if (tPage >= 1 && tPage <= this.total) {
        this.curPage = tPage
      }
    },
    changeClass (key) {
      this.curPage = 1
      this.curClass = key
      this.isAdSearch = false
      this.getData(true)
    },
    changeAlpha (key) {
      this.curPage = 1
      this.curAlpha = key
      this.getData(true)
    },
    changeOrder (key) {
      this.curPage = 1
      this.sortOrder = key
      this.getData(false)
    },
    pickWord (word) {
      this.searchValue = word
      this.searchBooks(true)
    },
    getCount () {
      let params = {
        sortOrder: this.sortOrder,
        pinyinIndex: this.curAlpha
      }
      if (this.isAdSearch) {
        params.advacedFilters = JSON.stringify({
          category: this.curClass,
          ...this.advacedFilters
        })
      } else {
        params.searchValue = Exchange(this.searchValue, false)
        params.category = this.curClass
      }
      api.selectCount(params).then(stat => {
        this.classList[0].num = 0
        for (let item of this.classList) {
          if (stat[item.key] !== undefined) {
            item.num = stat[item.key]
            if (this.curClass !== 'all' && this.curClass === item.key) {
              this.total = Math.ceil(stat[item.key] / this.pageSize)
            }
            this.classList[0].num += stat[item.key]
          }
          if (this.curClass === 'all') {
              this.total = Math.ceil(this.classList[0].num / this.pageSize)
            }
        }
      })
    },
    getSearchKeywords () {
      api.selectSearchKeywords({
        pageSize: 5
      }).then(res => {
        res.rows.forEach(item => {
          this.searchKeywords.push(item.keyword);
        });
      })
    }
  },
  mounted () {
    if (window.location.href.includes('?')) {
      let queryObj = getSearchParams(window.location.href)
      this.curClass = queryObj.category
      if (queryObj.input) {
        this.searchValue = queryObj.input
        this.handleSearch()
      } else {
        this.advacedFilters = JSON.parse(queryObj.advacedFilters)
        this.handleAdSearch(queryObj.category, JSON.parse(queryObj.advacedFilters))
      }
    } else {
      this.searchBooks(true)
    }
    this.getSearchKeywords();
  },
  watch: {
    curPage () {
      this.getData(false)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
// @media screen and (min-width: 769px) {
  @import "./literature-web.less";
// }
// @media screen and (max-width: 768px) {
//   @import "./literature-mobile.less";
// }
</style>
